import { createFileRoute, Outlet } from "@tanstack/react-router";

// Pages own their layout: the overview scrolls with a full-bleed hero, the
// analysis pages fill the viewport with their own panes.
export const Route = createFileRoute("/analytics")({
  component: () => (
    <div className="h-full min-h-0">
      <Outlet />
    </div>
  ),
});
